import React, {
  useRef,
  useReducer,
  useState,
  useCallback,
  useEffect,
} from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { PageHeading } from '../../../../../../SharedComponents';
import { Avatar, ButtonBase } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import {
  Inputs,
  Tables,
  AutocompleteComponent,
  DatePickerComponent,
  SelectComponet,
} from '../../../../../../Components';
import {
  getDownloadableLink,
  getFirstLastNameLetters,
  showError,
  showSuccess,
  GlobalHistory,
} from '../../../../../../Helper';
import {
  OrganizationUserSearch,
  GetAllBranches,
  ApproveUserActivation,
} from '../../../../../../Services';
import { UserActivationRejectDialog } from '../../Dialogs';
import { UpdatedUserStatus } from '../../../../../../Enums';
import HistoryDialog from './HistoryDialog';
import { DateRangePickerComponent } from "../../../../../../Components/Controls/DateRangePickerComponent/DateRangePickerComponent";

const statusArray = [
  { name: 'PendingLineManagerUserActivation', value: 4 },
  { name: 'PendingTrainingCenterActivation', value: 5 },
  { name: 'PendingCRMAdminActivation', value: 6 },
];

 
export const PendingActivationView = ({
  parentTranslationPath,
  translationPath,
  usersData,
  totalCount,
  setFilter,
  filter,
  reloadData,
  onPageSizeChanged,
  onPageIndexChanged,
  setSelected,
  selected,
  dateRangeDefault,
  setIsDatePickerChanged,
  initialFilter
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const typingTimer = useRef(null);

  const reducer = (state, action) => {
    if (action.id !== 'edit') return { ...state, [action.id]: action.value };
    return {
      ...action.value,
    };
  };
  const [isRejectDialogOpen, setIsRejectDialogOpen] = useState(false);
  const [data, setData] = useReducer(reducer, {
    systemUsers: [],
    branches: [],
  });
  const [activeItem, setActiveItem] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const getSystemUsers = async ({name ,userName}) => {
    const res = await OrganizationUserSearch({
      pageIndex: 0,
      pageSize: 10,
      name: name || '',
      userName: userName || '',
    });
    if (!(res && res.status && res.status !== 200)) {
      const localValue = (res && res.result) || [];
      if (localValue.length > 0) {
        setData({ id: 'systemUsers', value: localValue });
      } else setData({ id: 'systemUsers', value: [] });
    }
  };

  const onClearedAllFiltersClick = useCallback(() => {
    setFilter((currentFilter) => ({
      ...initialFilter,
      status: currentFilter.status,
    }));
    setSelected({
      id: 'edit',
      value: {
        lineManager: null,
        branch: null,
        userName: null,
        dateFilter: dateRangeDefault,
      },
    });
  }, []);
  const approveUserActivation = async (userId) => {
    setIsLoading(true);
    const res = await ApproveUserActivation(userId);
    if (!(res && res.status && res.status !== 200)) {
      showSuccess(t(`${translationPath}activate-approval-success`));
    } else showError(t(`${translationPath}activate-approval-failed`));
    await reloadData();
    setIsLoading(false);
  };

  // useEffect(() => {
  const filterDateChanged = (selectedDate) => {
    setSelected({
      id: "dateFilter",
      value: {
        startDate: selectedDate?.selection?.startDate,
        endDate: selectedDate?.selection?.endDate,
        key: 'selection',
        selectedDateType: selectedDate.selection?.selectedDateType,
      },
    });
    setIsDatePickerChanged(false)
  };

  useEffect(()=>{
    setFilter((items) => ({
      ...items,
      status: UpdatedUserStatus.PendingActivation.value || 1,
    }));
  }, []);
  return (
    <div className='w-80'>
      <div className='d-flex-column'>
        <PageHeading
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          headerTitle={'PendingActivation'}
          subTitle={'Pending-Activation-heading'}
          wrapperClasses={'px-4 w-50'}
          headerTitleClasses={'fz-16 mb-1'}
          subTitleClasses={'fz-14 m-0 ml-0'}
        />

        <div className='d-flex'>
          <div className='w-100 px-4 d-flex flex-wrap'>
            <div className='w-100 d-flex fa-center fa-start'>
              <Inputs
                idRef='user-nameRef'
                labelClasses='mt-4'
                wrapperClasses='w-100 mt-2 mr-3'
                value={filter.userName || ''}
                onInputChanged={(event) => {
                  const userName = event?.target?.value;
                  setFilter((items) => ({
                    ...items,
                    userName: userName || null,
                    userId: null,
                  }));
                }}
                inputPlaceholder={t(`${translationPath}full-Name`)}
              />
              <Inputs
                idRef='mobileNumber-ref'
                labelClasses='mt-4'
                wrapperClasses='w-100 mt-2 mr-3'
                value={filter.mobileNumber || ''}
                onInputChanged={(event) => {
                  const mobileNumber = event?.target?.value;
                  setFilter((items) => ({
                    ...items,
                    mobileNumber: mobileNumber || null,
                  }));
                }}
                inputPlaceholder={t(`${translationPath}mobile-Number`)}
              />
              <Inputs
                idRef='Createdby-ref'
                labelClasses='mt-4'
                wrapperClasses='w-100 mt-2 mr-3'
                value={filter.createdBy || ''}
                onInputChanged={(event) => {
                  const createdBy = event?.target?.value;
                  setFilter((items) => ({
                    ...items,
                    createdBy: createdBy || null,
                  }));
                }}
                inputPlaceholder={t(`${translationPath}created-by`)}
              />
                        <div className='d-inline-flex'>
              <div className='item-filter' >
                <SelectComponet
                  data={[
                    { key: 1, value: t(`${translationPath}Pending-activation-Date`) }
                  ]}
                  defaultValue={{
                    key: 1,
                    value: t(`${translationPath}Pending-activation-Date`),
                  }}
                  value={selected.dateFilter?.selectedDateType || 1}
                  valueInput='key'
                  textInput='value'
                  isDisabled={isLoading}
                  onSelectChanged={(value) => {
                    setIsDatePickerChanged(true);
                    setSelected((f) => ({
                      ...f,
                      selectedDateType: value,
                    }));
                  }}
                  wrapperClasses='w-auto'
                  themeClass='theme-transparent'
                  idRef='Date_Select'
                />
              </div>
              <DateRangePickerComponent
                onClearClicked={() => {
                  setSelected({
                    id: "dataFilter",
                    value: dateRangeDefault,
                  });
                  filterDateChanged(dateRangeDefault);
                  setFilter((f) => ({
                    ...f,
                    startDate: null,
                    endDate: null
                  }));
                }}
                onDialogClose={() => setIsDatePickerChanged(true)}
                ranges={[selected.dateFilter]}
                // parentTranslationPath={parentTranslationPath}
                // translationPath={translationPath}
                onDateChanged={(selectedDate) => {
                  filterDateChanged(selectedDate)
                }}
              />
            </div>
            </div>
            <div className="w-100 d-flex-center fa-start">
              <Inputs
                idRef='email-ref'
                labelClasses='mt-4'
                wrapperClasses='w-100 mt-2 mr-3'
                value={filter.email || ''}
                onInputChanged={(event) => {
                  const email = event?.target?.value;
                  setFilter((items) => ({
                    ...items,
                    email: email || null,
                  }));
                }}
                inputPlaceholder={t(`${translationPath}email`)}
              />
              <Inputs
                idRef='branch-NameRef'
                labelClasses='mt-4'
                wrapperClasses='w-100 mt-2 mr-3'
                value={filter.branchName || ''}
                onInputChanged={(event) => {
                  const branchName = event?.target?.value;
                  setFilter((items) => ({
                    ...items,
                    branchName: branchName || null,
                  }));
                }}
                inputPlaceholder={t(`${translationPath}branch-Name`)}
              />
              <Inputs
                idRef='Createdby-ref'
                labelClasses='mt-4'
                wrapperClasses='w-100 mt-2 mr-3'
                value={filter.staffId || ''}
                onInputChanged={(event) => {
                  const staffId = event?.target?.value;
                  setFilter((items) => ({
                    ...items,
                    staffId: staffId || null,
                  }));
                }}
                inputPlaceholder={t(`${translationPath}staff-ID`)}
              />
            </div>
            <div className='w-100 d-flex flex-wrap fa-start'>
              <AutocompleteComponent
                idRef='lineManagerRef'
                labelClasses='Requierd-Color'
                inputPlaceholder={t(`${translationPath}line-manager`)}
                selectedValues={selected.lineManager}
                wrapperClasses='w-25 mt-2 mr-3'
                data={data.systemUsers || []}
                withoutSearchButton
                multiple={false}
                displayLabel={(option) => option?.fullName || ''}
                onChange={(event, newValue) => {
                  setSelected({
                    id: 'lineManager',
                    value: newValue,
                  });
                  setFilter((items) => ({
                    ...items,
                    lineManagerId: newValue?.id || null,
                  }));
                }}
                onOpen={() => {
                  if (data.systemUsers && data.systemUsers.length == 0)
                    getSystemUsers({});
                }}
                onInputKeyUp={(e) => {
                  const { value } = e.target;
                  if (typingTimer) clearTimeout(typingTimer.current);
                  typingTimer.current = setTimeout(() => {
                    getSystemUsers({ name: value });
                  }, 1200);
                }}
              />
              <AutocompleteComponent
                idRef='user-NameRef'
                labelClasses='Requierd-Color'
                inputPlaceholder={t(`${translationPath}user-Name`)}
                selectedValues={selected.userName}
                wrapperClasses='w-25 mt-2'
                data={data.systemUsers || []}
                withoutSearchButton
                multiple={false}
                displayLabel={(option) => option?.userName || ''}
                onChange={(event, newValue) => {
                  setSelected({
                    id: 'userName',
                    value: newValue,
                  });
                  setFilter((items) => ({
                    ...items,
                    userUserName: newValue?.userName || null,
                  }));
                }}
                onOpen={() => {
                  if (data.systemUsers && data.systemUsers.length == 0)
                    getSystemUsers({});
                }}
                onInputKeyUp={(e) => {
                  const { value } = e.target;
                  if (typingTimer) clearTimeout(typingTimer.current);
                  typingTimer.current = setTimeout(() => {
                    getSystemUsers({ userName: value });
                  }, 1200);
                }}
              />
              <SelectComponet
                data={statusArray}
                valueInput={'value'}
                wrapperClasses='w-25 mt-2 ml-2'
                textInput={'name'}
                value={filter.userStatusId}
                parentTranslationPath={parentTranslationPath}
                translationPathForData={translationPath}
                translationPath={translationPath}
                emptyItem={{
                  value: null,
                  text: 'status',
                  isDisabled: true,
                }}
                onSelectChanged={(newValue) => {
                  setFilter((items) => ({
                    ...items,
                    userStatusId: +newValue ?? null,
                  }));
                }}
              />
            </div>
          </div>
          <div className='mt-3'>
            <ButtonBase
              onClick={onClearedAllFiltersClick}
              id='onClearedAllFiltersref'
              // disabled={isAllFormFieldsLoading}
              className='btns theme-solid bg-danger clear-all-btn px-4'
            >
              <span className='mdi mdi-filter-remove m-1' />
              {t(`${translationPath}clear-filters`)}
            </ButtonBase>
          </div>
        </div>
      </div>
      <div className='propx-view-container sm m-3'>
        <Tables
          data={usersData || []}
          headerData={[
            {
              id: 1,
              label: 'user',
              component: (item) =>
                (item?.name ? (
                  <div className='d-flex-v-center'>
                    <div className='campaign-team-f1'>
                      <Avatar
                        className='avatars-wrapper team-avatar fz-12 sm-theme'
                        src={
                          item?.profileImage
                            ? getDownloadableLink(item?.profileImage)
                            : ''
                        }
                      >
                        {getFirstLastNameLetters(item?.name || '')}
                      </Avatar>
                    </div>
                    <div className='d-flex-column'>
                      <span className='fz-12 fw-simi-bold'>
                        {item?.name || '-'}
                      </span>
                      <span className='fz-10 text-tertiary'>
                        {item?.email || '-'}
                      </span>
                    </div>
                  </div>
                ) : (
                  '-'
                )) || '',
            },
            {
              id: 2,
              label: 'branch',
              input: 'branch',
              component: (item) => <span>{item?.branch}</span> || '',
            },
            {
              id: 3,
              label: 'Line-manager',
              input: 'lineManager',
            },
            {
              id: 4,
              label: 'Pending-activation-Date',
              input: 'creationDate',
              component: (item) =>
                (
                  <span>
                    {item?.creationDate
                      ? moment(item?.creationDate).format('LL')
                      : null}
                  </span>
                ) || '',
            },
            {
              id: 5,
              label: 'status',
              input: 'userStatus',
              component: (row) => (
                <HistoryDialog
                  parentTranslationPath={parentTranslationPath}
                  translationPath={translationPath}
                  {...row}
                />
              ),
            },
            {
              id: 5,
              label: 'Created-by',
              input: 'createdByName',
            },
            {
              id: 6,
              label: 'actions',
              component: (item) =>
                (
                  <span className='d-flex fj-start'>
                    {item?.showRejectButton && (
                      <Button
                        className='btns propx-action-btn theme-propx outlined danger'
                        onClick={() => {
                          setActiveItem(item);
                          setIsRejectDialogOpen(true);
                        }}
                      >
                        {t(`${translationPath}reject`)}
                      </Button>
                    )}
                    {item?.showConfirmButton && (
                      <Button
                        className='btns propx-action-btn p-1 theme-propx outlined gold'
                        onClick={() =>
                          (!isLoading && item?.id) ? approveUserActivation(item?.id) : null
                        }
                      >
                        {t(`${translationPath}confirm`)}
                      </Button>
                    )}
                    <Button
                      className='btns propx-action-btn p-1 theme-propx gold-text'
                      onClick={() =>
                        item.id
                          ? GlobalHistory.push(`/home/Users/edit?id=${item.id}`)
                          : null
                      }
                    >
                      {t(`${translationPath}show-details`)}
                    </Button>
                  </span>
                ) || '',
            },
          ]}
          itemsPerPage={filter.pageSize}
          activePage={filter.pageIndex}
          totalItems={totalCount}
          onPageIndexChanged={onPageIndexChanged}
          onPageSizeChanged={onPageSizeChanged}
          defaultActions={[]}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
        />
      </div>
      {isRejectDialogOpen && (
        <UserActivationRejectDialog
          activeItem={activeItem}
          isDialogOpen={isRejectDialogOpen}
          setIsDialogOpen={setIsRejectDialogOpen}
          reloadData={reloadData}
          onCloseClicked={() => {
            setIsRejectDialogOpen(false);
            setActiveItem(null);
          }}
          onCancelClicked={() => {
            setIsRejectDialogOpen(false);
            setActiveItem(null);
          }}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
        />
      )}
    </div>
  );
};
